import { SPEED_UNIT } from './speed-unit.token';

export const provideSpeedUnit = (unit?: string) => ({
    provide: SPEED_UNIT,
    useValue: unit,
});
